import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { filterInitialValue } from "../util";
import SimpleDate from "../../../../modules/SimpleDate";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import moment from "moment";

class MasterPackageFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: filterInitialValue,
      noPeriodData: [
        { label: "YA", value: true },
        { label: "TIDAK", value: false },
      ],
      cabangOptions: [],
    };
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filter } = this.state;
    onSubmit(filter);
  };

  handleClear = () => {
    this.setState({
      filter: filterInitialValue,
    });
  };

  handleSetValue = ({ value, name }) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  componentDidMount() {
    const { submitedFilter } = this.props;
    if (submitedFilter) {
      this.setState({ filter: submitedFilter });
    }
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Master Package",
      setError: this.props.setError,
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res?.data?.data?.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item?.kodeCabang)
      );
      this.setState({
        cabangOptions:
          filteredData?.map((item) =>
            mapToObjectDDL(item?.namaDealer, item?.kodeCabang)
          ) || [],
      });
    }
    this.props.triggerLoading();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { filter, noPeriodData, cabangOptions } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter"
          visible={visible}
          styles={{ width: "50%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView column style={{ gap: "15px" }}>
                <SimpleInput
                  name="idPackage"
                  label="Paket ID"
                  value={filter.idPackage}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleInput
                  name="packageName"
                  label="Nama Paket"
                  value={filter.packageName}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleDDL
                  label="Cabang Berlaku"
                  id="select_status"
                  box="multiselect"
                  name="cabangBerlaku"
                  options={cabangOptions}
                  value={filter?.cabangBerlaku}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "cabangBerlaku" })
                  }
                />
                <SimpleInput
                  label="Kode Varian"
                  name="kodeVariant"
                  value={filter.kodeVariant}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <FlexView column>
                  <div className="txt-site txt-11 txt-main txt-bold margin-5px">
                    <h4>Tanggal Mulai dan Selesai Package</h4>
                  </div>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleDate
                      id="select_date_startDate"
                      name="startDate"
                      styles={{ flex: 1 }}
                      nextdate
                      date={filter.startDate}
                      maxDate={filter.endDate}
                      onChange={(value) =>
                        this.handleSetValue({
                          value: moment(value).format("DD-MM-YYYY"),
                          name: "startDate",
                        })
                      }
                    />
                    <span className="margin-bottom-20px">To</span>
                    <SimpleDate
                      id="select_date_endDate"
                      name="endDate"
                      nextdate
                      date={filter.endDate}
                      onChange={(value) =>
                        this.handleSetValue({
                          value: moment(value).format("DD-MM-YYYY"),
                          name: "endDate",
                        })
                      }
                    />
                  </FlexView>
                </FlexView>
                <SimpleInput
                  label="Grace Period"
                  name="gracePeriod"
                  value={filter.gracePeriod}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleDDL
                  label="No Period"
                  id="select_status"
                  name="noPeriod"
                  box="search"
                  placeholder="YA / TIDAK"
                  options={noPeriodData}
                  value={filter.noPeriod}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "noPeriod" })
                  }
                />
              </FlexView>
              <FlexView style={{ justifyContent: "flex-end" }}>
                <FlexView style={{ gap: "10px" }}>
                  <SimpleButton text="Hapus" onClick={this.handleClear} />
                  <SimpleButton text="Terapkan" onClick={this.handleSubmit} />
                </FlexView>
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterPackageFilter;
